import { IAuthClient } from "@micro-frontend-react/employee-experience/lib/IAuthClient";
import { IHttpClient, } from "@micro-frontend-react/employee-experience/lib/IHttpClient";
import { SagaIterator } from "redux-saga";
import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';
import { ApiEndpoints, Messages } from '../Services/Constants'
import { SecurityFeatureActionType } from "../Redux/FeatureFlag/action-types";
import { receiveSecurityFeature, receiveSecurityFeatureError } from "../Redux/FeatureFlag/action";
import { FeatureFlagListActionType } from "../Redux/FeatureFlag/action-types";
import { receiveFeatureFlagList, receiveFeatureFlagListError } from "../Redux/FeatureFlag/action";

function auth(authClient: IAuthClient) {
    return Promise.resolve(authClient.acquireToken(__SCOPES__));
}

export function* requestSecurityFeatureSagas(): SagaIterator {
    yield all([takeLatest(SecurityFeatureActionType.REQUEST_SECURITY_FEATURE, requestSecurityFeature)]);
}

function* requestSecurityFeature(request: any): SagaIterator {
    const httpClient: IHttpClient = yield getContext('httpClient');
    try {
        const result = yield call([httpClient, httpClient.request], {
            url: `${ApiEndpoints.GetIsEnabledByFeatureName}${encodeURIComponent(request.featureName.trim())}`,
            method: 'GET',
        });
        if (result && result.status == 200) {
            yield put(receiveSecurityFeature(result.data));
        } else {
            yield put(receiveSecurityFeature(null));
            yield put(
                receiveSecurityFeatureError(
                    (result?.status + ' ' + result?.statusText) || Messages.FeatureFlagByName_Retrieve_Error_Message
                )
            );
        }
    } catch (ex) {
        yield put(receiveSecurityFeature(null));
        yield put(receiveSecurityFeatureError(Messages.FeatureFlagByName_Retrieve_Error_Message));
    }
}

// Feature Flag List - GetFeatureNamesAsync
export function* requestFeatureFlagListSagas(): SagaIterator {
    yield all([takeLatest(FeatureFlagListActionType.REQUEST_FEATURE_FLAG_LIST, requestFeatureFlagList)]);
}

function* requestFeatureFlagList(): SagaIterator {
    const httpClient: IHttpClient = yield getContext('httpClient');
    try {
        const result = yield call([httpClient, httpClient.request], {
            url: ApiEndpoints.GetFeatureNamesAsync,
            method: 'GET',
        });
        if (result && result.status == 200 && result.data?.status === 'success') {
            yield put(receiveFeatureFlagList(result.data.enabledFeatureflags || []));
        } else {
            yield put(receiveFeatureFlagList([]));
            yield put(
                receiveFeatureFlagListError(
                    `${result?.status ?? ''} ${result?.statusText ?? ''}`.trim() || Messages.FeatureFlag_Retrieve_Error_Message
                )
            );
        }
    } catch (ex) {
        yield put(receiveFeatureFlagList([]));
        yield put(receiveFeatureFlagListError(Messages.FeatureFlag_Retrieve_Error_Message));
    }
}